import type { AllocationPeriodUi } from "../types/time-allocation.ts";

export const PERIOD_OPTIONS: ReadonlyArray<{
  value: AllocationPeriodUi;
  label: string;
}> = [
  { value: "MONTHLY", label: "Monthly" },
  { value: "WEEKLY", label: "Weekly" },
  { value: "CUSTOM", label: "Custom" },
];
